module.exports = __webpack_public_path__ + "static/media/no-logo.bc6f91b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-logo.png
// module id = 633
// module chunks = 3